import { useSelector } from "react-redux"
import { Button } from "components/Button"
import { Buttons } from "components/Card/Card"
import { CallState } from "types/payload"
import { PaymentStore } from "types/store"
import React from "react"
import { useLanguage } from "locales"

const Canceled: React.FC<{
  loading?: boolean
  cancelState?: CallState.CANCELLED_BY_PATIENT | CallState.CANCELLED_BY_DOCTOR
  createCall: () => void
  logout: () => void
}> = ({ createCall, logout }): JSX.Element => {
  const { languages } = useLanguage()
  const loading = useSelector(({payment}: {payment: PaymentStore}) => payment.loading)
  const isFastPass = useSelector(({call}: any) => call?.call?.is_fast_pass);
  return (
    <Buttons>
      <div style={{display: 'flex', flexDirection: 'column', gap: '10px', textAlign: 'center'}}>
        <Button loading={loading} disabled={loading} onClick={createCall}>
          {languages.askAgain}
        </Button>
        {
          isFastPass && <span style={{ color: "#211452" }}>{languages.youWillAttendedInPriority}</span>
        }
      </div>
      <Button style={{ marginBottom: isFastPass ? '30px' : undefined }} type="link" onClick={() => logout()}>
        {languages.logout}
      </Button>
    </Buttons>
  )
}

export default Canceled
